module.exports = __webpack_public_path__ + "img/sellSincerityPayMentError.e3d7a315.png";